import { SagaIterator } from "redux-saga";
import { put, select, takeLatest } from "typed-redux-saga";
import { AnyAction } from "redux";
import { Action } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import {
	FormEngineActions,
	FormEngineSelectors
} from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events, ModelSelectors } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

import { assertNonNullable } from "../../../utilities/assert";
import { getButtonAnnotations } from "../../../utilities/modelHelpers";
import { OPEN_OPENREGISTER_SEARCH_MODAL } from "../../../utilities/variables/customEventNames";
import { OPENREGISTER_PATH, MAPPING_CONFIGURATION } from "../../../utilities/variables/modulfRuntimeAnnotations";

import { OpenregisterSearchModalDescriptor } from "../descriptors";

export function* openSearchModalSaga(): SagaIterator<void> {
	yield* takeLatest(
		(action: AnyAction) => {
			return (
				FormEngineActions.event.match(action) &&
				Events.eventButton.match(action.payload.engineEvent) &&
				action.payload.engineEvent.payload.name === OPEN_OPENREGISTER_SEARCH_MODAL
			);
		},
		function* (action: Action<FormEngineActions.FormEngineEventActions<Action<Events.EventButtonPayload>>>) {
			const { activityId } = action.payload;

			const engineState = yield* select(FormEngineSelectors.engineState(activityId));
			assertNonNullable(engineState);

			const formModel = ModelSelectors.formModel()(engineState);
			const { buttonPath } = action.payload.engineEvent.payload;
			const annotations = getButtonAnnotations(formModel, buttonPath);

			const openregisterPath = annotations.find(it => it.name === OPENREGISTER_PATH)?.value;
			const mappingConfigurationId = annotations.find(it => it.name === MAPPING_CONFIGURATION)?.value;

			if (!openregisterPath || !mappingConfigurationId) {
				return;
			}

			yield* put(
				ActivityActions.create({
					activityDescriptor: OpenregisterSearchModalDescriptor.build({
						openregisterPath,
						mappingConfigurationId,
						sourceActivityId: activityId
					}),
					initiatingActivityId: activityId,
					loadingState: "without"
				})
			);
		}
	);
}
